/** Cache-bust when Marsilya original poster PNGs change */
export const ORIGINAL_COVER_VER = "15";

export const originalCover = (file) => `/originals/${file}?v=${ORIGINAL_COVER_VER}`;

export const ORIGINAL_COVERS = {
  aviator: originalCover("aviator.png"),
  dice: originalCover("zar.png"),
  zar: originalCover("zar.png"),
  mines: originalCover("mines.png"),
  mayin: originalCover("mines.png"),
  plinko: originalCover("plinko.png"),
  limbo: originalCover("limbo.png"),
  wheel: originalCover("wheel.png"),
  cark: originalCover("wheel.png"),
  blackjack: originalCover("blackjack.png"),
};

export function coverForOriginalKey(key) {
  const k = String(key || "").toLowerCase();
  return ORIGINAL_COVERS[k] || "";
}
